import React from "react";
import { Scrollbars } from "react-custom-scrollbars";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Events from "../Events";

const EventsTab = ({ newTraining, value, onChange, onClick }) => (
  <div className="trainingEventsContent">
    <div className="trainingEventsBlock">
      <Scrollbars>
        <Events newTraining={newTraining} />
      </Scrollbars>
      <div className="trainingEventsActiveFooter">
        <TextField
          id="textareaTrainingEvents"
          name="addTrainingEvent"
          margin="dense"
          variant="outlined"
          multiline
          rows={3}
          placeholder="Напишите сообщение..."
          type="text"
          value={value}
          onChange={(e) => {
            onChange(e.target.value);
          }}
        />
        <Button onClick={onClick} disabled={value === ""}>
          Отправить
        </Button>
      </div>
    </div>
  </div>
);

export default EventsTab;
